import {useTranslations} from 'next-intl';
import {Section} from '@/section';
import Container from '@/container';
import {withBgNeutral200} from '@/hocs/withColors';
import LogosCarousel, {type CustomerLogo} from '@/ui/logos-carousel';
import styles from './styles.module.scss';

const BgSection = withBgNeutral200(Section);

const LOGO_BASE = '/static/images/home/customer-logos';

const CompanyLogoSection = () => {
  const t = useTranslations('customers.companyLogoSection');
  const tHomepage = useTranslations('homepage.customerLogos');
  const logos = tHomepage.raw('logos') as CustomerLogo[];

  return (
    <BgSection className={styles.section}>
      <Container>
        <LogosCarousel
          logos={logos}
          logoBase={LOGO_BASE}
          ariaLabel={t('ariaLabel')}
          fadeColor="#f7f5f1"
          muted
          className={styles.carousel}
        />
      </Container>
    </BgSection>
  );
};

export default CompanyLogoSection;
